import { List } from "@logicsoftware/react-virtualized";
import * as React from "react";
import { VerticalScrollbars } from "../scrollbars/VerticalScrollbars";

type CustomScrollBarWrapperProps = {
    children: React.ReactElement;
    style: React.CSSProperties;
};

export const CustomScrollBarWrapper = React.forwardRef(
    ({ children, style }: CustomScrollBarWrapperProps, ref: React.RefObject<List>) => {
        const scrollbarRef = React.useRef<VerticalScrollbars>();

        React.useEffect(() => {
            (ref.current.Grid as any)._scrollingContainer = scrollbarRef.current.getContentEl();
        });

        const handleScroll = (e: React.SyntheticEvent) => (ref.current.Grid as any)._onScroll(e);

        return (
            <VerticalScrollbars
                ref={scrollbarRef}
                wrapperProps={{ style }}
                initPreventWheel={true}
                contentProps={{ onScroll: handleScroll }}
            >
                {children}
            </VerticalScrollbars>
        );
    }
);
